import { IconButton, ListItemIcon, Menu, MenuItem, Tooltip } from '@material-ui/core';
import { HelpOutline, MenuBookOutlined, NewReleasesOutlined } from '@material-ui/icons';
import { FAQ_PATH } from '@components/WhatsNew';
import { WHATS_NEW_COUNT_EVENT, getWhatsNewCount, openWhatsNew } from '@components/WhatsNew/events';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

// The ? at the top right of every dashboard page: What's new and the FAQ.
// The dot means there are features this user has not been shown yet; the
// count comes from the What's new host in containers/App, which already asked.
export function HelpMenu({ iconColor = '#565656' }) {
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const [newCount, setNewCount] = useState(getWhatsNewCount());

  useEffect(() => {
    const onCount = event => setNewCount(event.detail || 0);
    window.addEventListener(WHATS_NEW_COUNT_EVENT, onCount);
    return () => window.removeEventListener(WHATS_NEW_COUNT_EVENT, onCount);
  }, []);

  const close = () => setAnchorEl(null);

  return (
    <>
      <Tooltip title="Help and what's new">
        <IconButton
          aria-label={newCount > 0 ? `Help and what's new, ${newCount} new` : "Help and what's new"}
          aria-haspopup="true"
          aria-controls="help-menu"
          data-testid="help-menu-button"
          size="small"
          onClick={event => setAnchorEl(event.currentTarget)}
          style={{ position: 'relative' }}>
          <HelpOutline style={{ color: iconColor }} />
          {newCount > 0 && (
            <span
              aria-hidden
              data-testid="help-menu-new-dot"
              className="absolute top-0.5 right-0.5 w-2 h-2 rounded-full bg-indigo-600 ring-2 ring-white"
            />
          )}
        </IconButton>
      </Tooltip>
      <Menu
        id="help-menu"
        anchorEl={anchorEl}
        keepMounted={false}
        open={Boolean(anchorEl)}
        onClose={close}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <MenuItem
          onClick={() => {
            close();
            openWhatsNew({ mode: 'all' });
          }}>
          <ListItemIcon style={{ minWidth: 32 }}>
            <NewReleasesOutlined fontSize="small" />
          </ListItemIcon>
          <span className="text-sm font-semibold text-slate-800">What&apos;s new</span>
          {newCount > 0 && (
            <span className="ml-3 text-[11px] font-bold px-2 py-0.5 rounded-lg bg-indigo-50 text-indigo-700">
              {newCount} new
            </span>
          )}
        </MenuItem>
        <MenuItem
          onClick={() => {
            close();
            history.push(FAQ_PATH);
          }}>
          <ListItemIcon style={{ minWidth: 32 }}>
            <MenuBookOutlined fontSize="small" />
          </ListItemIcon>
          <span className="text-sm font-semibold text-slate-800">FAQ</span>
        </MenuItem>
        <li className="px-4 pt-2 pb-1 text-xs text-slate-400 list-none" aria-hidden>
          Press ? to open What&apos;s new
        </li>
      </Menu>
    </>
  );
}

HelpMenu.propTypes = {
  iconColor: PropTypes.string
};

export default HelpMenu;
